import { memo } from 'react'
import { IntakeFormsTableTitle } from './IntakeFormsTableTitle/IntakeFormsTableTitle'
import { IntakeFormsTableBody } from './IntakeFormsTableBody/IntakeFormsTableBody'

const IntakeForms = memo(() => (
  <div>
    <IntakeFormsTableTitle />
    <IntakeFormsTableBody />
  </div>
))

IntakeForms.displayName = 'IntakeForms'

export { IntakeForms }
